export var ValidationRuleType;
(function (ValidationRuleType) {
    ValidationRuleType["STRING"] = "STRING";
    ValidationRuleType["NUMBER"] = "NUMBER";
    ValidationRuleType["INTEGER"] = "INTEGER";
    ValidationRuleType["DATE"] = "DATE";
})(ValidationRuleType || (ValidationRuleType = {}));
